import { call, put, select } from 'redux-saga/effects';
import { signalingBreakoutRoomMessageBroadcast } from 'features/breakout-rooms/actions';
import { Action } from '@reduxjs/toolkit';
import i18n from 'i18n';
import { addActionNotification } from 'features/notifications/action-notifications/addActionNotification';
import { selectLocalUserId } from 'features/users/usersSlice';
import { User, UserId } from 'features/users/types';
import { resolveEventUserSaga } from 'features/users/utils/resolveEventUser';
import { EventUser } from 'services/signaling';

export function* onMessageBroadcastSaga(
  action: ReturnType<typeof signalingBreakoutRoomMessageBroadcast>
) {
  const { message, initiator } = action.payload;

  const localUserId: UserId = yield select(selectLocalUserId);
  if (localUserId === initiator.id) {
    // don't show the notification to the initiator
    return;
  }

  const resolvedInitiator: User | EventUser | undefined = yield call(
    resolveEventUserSaga,
    initiator
  );

  const initiatorName = resolvedInitiator?.name;
  const hasInitiatorName = !!initiatorName;

  const notificationContent = hasInitiatorName
    ? i18n.t('notifications:breakout_rooms.moderator_broadcast_message', {
        username: initiatorName,
        message,
      })
    : i18n.t('notifications:breakout_rooms.moderator_broadcast_message_unnamed', {
        message,
      });

  const actionNotificationThunk: Action = yield call(addActionNotification, {
    content: notificationContent,
    ...(hasInitiatorName && { initiator: resolvedInitiator }),
    scope: ['breakout-room'],
  });

  yield put(actionNotificationThunk);
}
